
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { RoleItemProps } from ".";
import { loading, create } from "store/role";
import { AppMessage } from "components";

interface ApiRoleCreateInputProps extends Omit<RoleItemProps, "id"> {
}

type ApiRoleCreateOutputProps = OutputBaseProps<{ item: RoleItemProps; }, ApiRoleCreateInputProps>

export const apiRoleCreate = async (data: ApiRoleCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiRoleCreateOutputProps>("/api/role/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};